import { Vector2 } from '../math/Vector2';

/**
 * Where an entity sits relative to its parent.
 *
 * Pure data, like a component: three plain fields and nothing else. The world-space equivalent is
 * derived on demand by walking the parent chain, so there is exactly one source of truth and no cached
 * matrix to invalidate.
 *
 * Rotation is in radians, counter-clockwise, zero pointing along +X.
 */
export class Transform {
  /** Position relative to the parent, in world units. */
  readonly position: Vector2;
  /** Rotation relative to the parent, in radians. */
  rotation: number;
  /** Scale relative to the parent; one means unscaled. */
  readonly scale: Vector2;

  constructor(position = Vector2.zero(), rotation = 0, scale = Vector2.one()) {
    this.position = position;
    this.rotation = rotation;
    this.scale = scale;
  }

  /** Copies position, rotation and scale from `source`. */
  copyFrom(source: Transform): this {
    this.position.copyFrom(source.position);
    this.rotation = source.rotation;
    this.scale.copyFrom(source.scale);
    return this;
  }
}
